<template>
  <v-page page="Slots Config" title="Schedule of Available Slots">
    <p>Review available slots in a login window or click on a range to override by group or globally.</p>
    <v-card class="mt-3">
      <slots-calendar
        :key="`calendar-${refresh}`"
        :range="true"
        :initial-date="initialDate"
        :initial-timezone.sync="timezone"
        :requiredSlotsCount="1"
        height="425px"
        location="Toronto"
        show-groups
        :disable-selection="!$can({ schedule: 'write' })"
        :group="globally ? false : group_id"
        v-model="selectedRange">
          <template v-slot:options>
          <v-form v-model="valid" ref="form">
            <v-toolbar flat class="mb-3 py-3">
              <div v-if="$can({ schedule: 'write' })" style="width: 200px" class="py-2">
                <v-text-field
                              v-model="slots"
                              type="number"
                              label="Total Slots for Each Hour"
                              placeholder="100"
                              :rules="[v => !!v || 'Please specify the number of slots']"/>
              </div>
              <div style="width: 400px" class="py-2 ml-4">
                <v-switch class="global-switch"
                          v-model="globally"
                          :label="typeLabel"
                          style="height: 68px"
                          color="success">
                  <template v-slot:append>
                    <v-text-field v-if="!globally"
                                  v-model="group_id"
                                  :label="$can({ schedule: 'write' })  ? 'Assessment Group' : 'By Assessment Group'"
                                  :placeholder="$can({ schedule: 'write' })  ? '...' : null"
                                  :rules="$can({ schedule: 'write' }) ? [v => ((!globally) && (!!v)) || 'Please specify assessment group'] : []">

                      <template v-slot:append>
                        <v-icon color="primary">lens</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                </v-switch>
              </div>
              <v-spacer></v-spacer>
              <template v-if="$can({ schedule: 'write' })">
                <template v-if="!selectedRange">No login windows selected</template>
                <template v-else>Override login windows in range:</template>
                &nbsp; &nbsp;
                <template v-if="selectedRange">
                <v-chip label
                        color="grey lighten-2"
                        text-color="black">
                  {{ selectedRangeInTimezone[0] | moment | dateTime }}
                </v-chip>
                  to
                <v-chip label
                        color="grey lighten-2"
                        text-color="black">
                  {{ (selectedRangeInTimezone[1] || selectedRangeInTimezone[0]) | addHours(1) | dateTime }}
                </v-chip>
              </template>
              </template>
              </v-toolbar>
            </v-form>
          </template>

        </slots-calendar>
        <v-card-actions v-if="$can({ schedule: 'write' })">
          <v-spacer/>
          <v-btn @click="save"
                 :disabled="!valid"
                 class="primary">Save</v-btn>
        </v-card-actions>
    </v-card>
  </v-page>
</template>

<script>
import VPage from '@/layouts/Default'
import SlotsCalendar from '@/components/SlotsCalendar'
import { getDefaultTimezoneIndex, timezones } from '@/services/time'
import moment from 'moment'
import { overrideAvailableSlots } from '@/services/Schedule'
import { Bus } from '@/bus'

export default {
  name: 'SlotsEditor',
  components: {
    SlotsCalendar,
    VPage
  },
  data () {
    return {
      valid: false,
      refresh: 0,
      selectedRange: null,
      timezone: getDefaultTimezoneIndex(),
      slots: null,
      initialDate: null,
      globally: false,
      group_id: null
    }
  },
  computed: {
    /**
     * Returns the selected range in the timezone the user selected
     */
    selectedRangeInTimezone () {
      return this.selectedRange
        ? this.selectedRange.map(date => moment.utc(date).tz(timezones[this.timezone].name))
        : null
    },
    /**
     * Type of update switch label
     */
    typeLabel () {
      return this.globally
        ? 'Globally'
        : ''
    }
  },
  methods: {
    /**
     * Saves the overwritten timeslots
     */
    save () {
      if (!this.$refs.form.validate()) {
        return
      }

      overrideAvailableSlots({
        fromDate: this.selectedRange[0],
        toDate: moment(this.selectedRange[this.selectedRange.length - 1]).add(1, 'hour').utc().toISOString(),
        slots: +this.slots,
        groupID: this.globally ? null : this.group_id
      }).then(() => {
        setTimeout(() => {
          Bus.$emit('alert', { color: 'success', message: 'Time slots overwritten' })
          this.reset()
        }, 500)
      })
    },
    reset () {
      this.initialDate = moment(this.selectedRange[0])
      this.selectedRange = null
      this.slots = null
      this.refresh++
    }
  }
}
</script>

<style lang="sass">
  .global-switch > .v-input__control
      margin-top: 12px
</style>
